import { useContext, useState } from "react";
import Helmet from "react-helmet";
import styled from "@emotion/styled";
import SideBar from "components/sidebar/Sidebar";
import NavBar from "components/navbar/NavBar";
import { useUpdateProfileMutation } from "generated/graphql";
import InputField, { TextArea } from "components/auth/InputField";
import "assets/css/w3.css";
import Loader from "react-loader-spinner";
import { LoggedInUserContext } from "contexts/user";

const SettingsPageWrapper = styled.div`
  * {
    padding: 0;
    margin: 0;
    text-decoration: none;
    list-style: none;
    box-sizing: border-box;
  }

  .w3-container,
  .w3-panel {
    padding: 0.01em 16px;
  }

  body {
    font-family: "Rajdhani", sans-serif;
    background-color: #282c38;
    color: #ffffff;
  }

  /* Side Navbar */

  .checkbtn {
    font-size: 30px;
    color: #ffffff;
    float: right;
    line-height: 80px;
    margin-right: 10px;
    /* margin-top: -40px; */
    cursor: pointer;
    display: none;
  }

  #check {
    display: none;
  }

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 20px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 30px;
    margin-left: 50px;
    margin-top: -20px;
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
    margin-top: -20px;
    margin-bottom: 30px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: 0px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 15px;
  }

  /* Tabs */

  /* .w3-bar-item:hover {
    background-color: #282C38;
} */

  /* Profile Tab */
  .row1 {
    @media (max-width: 640px) {
      margin-top: 1rem !important;
    }
  }

  .column1 {
    width: 50%;
    float: left;
    margin-top: 20px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }
    @media (max-width: 1024px) {
      float: unset;
      width: 100%;
    }
  }

  .column2 {
    width: 50%;
    float: right;
    margin-top: 20px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }
    @media (max-width: 1024px) {
      float: unset;
      width: 100% !important;
    }
  }

  input[type="text"],
  select,
  textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
  }

  input[type="submit"],
  button.submit-button {
    background-color: #701129;
    color: white;
    padding: 14px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button.active-section {
    background: #000000f4;
    font-weight: bold;
  }

  /* Reset Password Tab */

  .column3 {
    width: 50%;
    float: left;
    margin-top: 20px;
    margin-bottom: 50px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }
    @media (max-width: 1024px) {
      float: unset;
      width: 100%;
    }
  }

  .column4 {
    width: 50%;
    float: right;
    margin-top: 20px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }
    @media (max-width: 1024px) {
      float: unset;
      width: 100%;
    }
  }

  .delete {
    margin-top: 20px;
    background-color: #fae7e7;
    width: 150px;
    height: 40px;
    color: red;
    font-weight: bold;
    border: 2px solid red;
    border-radius: 4px;
  }

  .column5 {
    width: 50%;
    float: left;
    margin-top: 20px;
    margin-bottom: 50px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }

    @media (max-width: 640px) {
      float: unset;
      width: 100%;
      margin-bottom: 1rem;
    }
  }

  .column6 {
    width: 50%;
    float: right;
    margin-top: 20px;
    &::after {
      display: block;
      content: "";
      clear: both;
    }

    @media (max-width: 640px) {
      float: unset;
      width: 100%;
      margin-bottom: 1rem;
    }
  }

  .password_form {
    width: 100%;
  }

  .password_form input {
    width: 100%;
    padding: 12px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #ffffff;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
  }

  .update_btn {
    background-color: #701129;
    width: 150px;
    height: 40px;
    color: #ffffff;
    border: 2px solid #701129;
    border-radius: 4px;
  }

  @media (max-width: 858px) {
    .profilePic {
      margin-right: 50px;
    }
    .sidebar {
      width: 0%;
      height: 0%;
    }
    .search {
      display: none;
    }
    .side-logo {
      width: 55px;
      height: 55px;
      margin-top: 0;
      margin-left: 5px;
    }
    .checkbtn {
      display: block;
    }
    .sidebar ul {
      position: fixed;
      width: 100%;
      height: 100vh;
      background: #701129;
      top: 70px;
      top: -100%;
      text-align: center;
      transition: all 0.5s;
    }
    #check:checked ~ .sidebar ul {
      top: 70px;
    }
    .w3-container {
      margin-left: 0px !important;
    }
    .w3-bar {
      margin-left: 0px !important;
    }
    #Profile h2 {
      font-size: 20px;
    }
    #Profile p {
      font-size: 13px;
    }
    .column4 {
      width: 40%;
    }
  }
`;

function SettingsPage() {
  const [updateProfileMutation, { loading: updatingProfile }] =
    useUpdateProfileMutation();
  const me = useContext(LoggedInUserContext);
  const [visibleSection, setVisibleSection] = useState("profile");
  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [bio, setBio] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  let partyDetailsMap = {};
  if (me) {
    partyDetailsMap = me?.partyDetails
      .map(({ key, value }: any) => ({
        [key]: value,
      }))
      .reduce((acc, val) => ({ ...acc, ...val }), {});
  }

  return (
    <SettingsPageWrapper>
      <Helmet>
        <title>Settings — Jiwe eSports</title>
      </Helmet>
      <SideBar
        nickname={me?.nickname}
        isLoggedIn={!!me?.nickname}
      />
      {me && (
        <NavBar nickname={me?.nickname} name={me?.name} />
      )}

      <div
        className="w3-container"
        style={{ marginLeft: "200px", paddingTop: "30px" }}
      >
        <h2>Settings</h2>
      </div>

      <div
        className="w3-bar "
        style={{ marginLeft: "200px", backgroundColor: "#1D2029" }}
      >
        <button
          className={`w3-bar-item w3-button ${
            visibleSection === "profile" ? "active-section" : ""
          }`}
          onClick={() => setVisibleSection("profile")}
        >
          Profile
        </button>
        <button
          className={`w3-bar-item w3-button  ${
            visibleSection === "resetPassword" ? "active-section" : ""
          }`}
          onClick={() => setVisibleSection("resetPassword")}
        >
          Reset Password
        </button>
        {/* <button className="w3-bar-item w3-button">Payment Settings</button> */}
      </div>

      {visibleSection === "profile" && (
        <div
          id="Profile"
          className="w3-container city"
          style={{ marginLeft: "200px" }}
        >
          <div className="row">
            <div className="column1">
              <h2>Profile</h2>
              <p>
                This information will be displayed publicly so be careful what
                you share.
              </p>
            </div>
            <div className="column2 clearfix">
              <form>
                <InputField
                  setValue={setNickname}
                  // @ts-ignore
                  value={nickname || me?.nickname}
                  placeholder="Your display name"
                  type="text"
                  name="nickname"
                  label="Display name"
                />
                <TextArea
                  name="subject"
                  label="Bio"
                  type="textarea"
                  // @ts-ignore
                  value={bio || partyDetailsMap["bio"]!}
                  setValue={setBio}
                  placeholder="Write something.."
                  // style={{ height: "200px" }}
                />
              </form>
            </div>
          </div>

          <div className="row1" style={{ marginTop: "300px" }}>
            <hr />
            <div className="column3">
              <h2>Personal Information</h2>
              <p>Use a permanent email address where you can receive mail.</p>
            </div>
            <div className="column4">
              <form>
                <InputField
                  setValue={setName}
                  // @ts-ignore
                  value={name || me?.name}
                  placeholder="Your name"
                  type="text"
                  name="name"
                  label="Name"
                />
                <InputField
                  setValue={setPhoneNumber}
                  // @ts-ignore
                  value={phoneNumber || me?.phoneNumber}
                  placeholder="Your phone number "
                  type="text"
                  name="phoneNumber"
                  label="Phone Number"
                />
                <InputField
                  setValue={setEmail}
                  // @ts-ignore
                  value={email || me?.email}
                  placeholder="Your email address "
                  type="text"
                  name="email"
                  label="Email address"
                />
                <button
                  className="submit-button"
                  style={{ marginTop: "10px" }}
                  type="submit"
                  disabled={updatingProfile}
                  onClick={(e) => {
                    e.preventDefault();
                    updateProfileMutation({
                      variables: {
                        input: {
                          email,
                          phoneNumber,
                          name,
                          bio,
                          nickname,
                        },
                      },
                    });
                  }}
                >
                  {!updatingProfile && "Save Changes"}
                  {updatingProfile && (
                    <Loader type="Bars" color="#fff" height={20} width={40} />
                  )}
                </button>
              </form>
            </div>
          </div>

          <div className="row2" style={{ marginTop: "300px", display: "none" }}>
            <hr />
            <div className="column3">
              <h2 style={{ color: "red" }}>Delete account</h2>
              <p>
                {" "}
                <b> Warning:</b> Deleting your account is irreversible.
              </p>
            </div>
            <div className="column4">
              <button className="delete">Delete Account</button>
            </div>
          </div>
        </div>
      )}

      {visibleSection === "resetPassword" && (
        <div
          id="Password"
          className="w3-container city"
          style={{ marginLeft: "200px" }}
        >
          <div className="row">
            <div className="column5">
              <h2>Reset Password</h2>
              <p>Password should have at least 8 characters</p>
            </div>
            <div className="column6">
              <form className="password_form">
                <label htmlFor="cpassword">Current Password</label>
                <input
                  type="password"
                  id="cpassword"
                  name="currentpassword"
                  placeholder="Current Password..."
                />

                <label htmlFor="npassword">New Password</label>
                <input
                  type="password"
                  id="npassword"
                  name="newpassword"
                  placeholder="New Password..."
                />

                <label htmlFor="conpassword">Confirm Password</label>
                <input
                  type="password"
                  id="conpassword"
                  name="confirmpassword"
                  placeholder="Confirm Password..."
                />

                <button className="update_btn">Update Password</button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* <div
        id="Payment"
        className="w3-container city"
        style={{ marginLeft: "200px" }}
      >
        <h1>Coming Soon</h1>
      </div> */}
    </SettingsPageWrapper>
  );
}

export default SettingsPage;
